import { Alert, Box, Button, Dialog, DialogActions, DialogContent, Grid, Snackbar, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ResourceMappingModal } from './modalComponent';
import { ReactComponent as EditIcon } from '../../../assets/PepWise2.0/edit-img.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/PepWise2.0/delete-img-new.svg';
import { ReactComponent as EditIconNew } from '../../../assets/PepWise2.0/Edit-Menu-Icon.svg';
import { ReactComponent as DeleteIconNew } from '../../../assets/PepWise2.0/Delete-Menu-Icon.svg';
import { exportProjectListByProgramId, fetchCopyProject, getProgramDetailsById, getProjectListByProgramId } from '../../../service/service';
import { Column } from 'react-data-grid';
import { CustomizedDataGrid } from '../../customized_data_grid';
import Loader from '../../Loader/loader';
import { useParams, useNavigate } from 'react-router-dom';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import DataInfoSecondary from 'components/Widgets/DataInfoSecondary';
import PageHeader from 'components/Header/Page';
import DashboardIcon from '../../../assets/material-symbols_dashboard.svg';
import RowTypography from 'components/Table/RowTypography';
import { ReactComponent as AddIcon } from '../../../assets/plus-icon.svg';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SubscriptTag from 'components/Widgets/SubscriptTag';
import eventEmitter from 'SnackBarEventEmitter';
import { ReactComponent as DuplicateIcon } from '../../../assets/PepWise2.0/fad_duplicate_new.svg';
import ProjectConfirmationDialog from './ProjectConfirmationDialog';
import moment from 'moment';
import { formatNumberWithCommas } from 'utils/common-util';
import PageWrapper from 'components/Common/PageWraper';
import MoreOptionMenu from 'components/Dropdown/MoreOptionSecondary';
import { MoveLeftIcon } from 'components/CommonIcons/Icons';
import DialogueModal from 'components/Modal/DialogModal';
import CopyToProgramModal from './CopyToProgramModal';

type ProjectCellProps = {
	row: any;
	onProjectClick: (row: any) => void;
};

const ProjectCell = ({
	row,
	onProjectClick
}: ProjectCellProps) => {
	const isNew = (updatedAt: any) => {
		const createdDate: any = new Date(updatedAt);
		const now: any = new Date();
		return (now - createdDate) / (1000 * 60 * 60 * 24) < 1;
	};
	return (
		<Stack direction="row" alignItems="center" sx={{ width: '100%' }}>
			<RowTypography onClick={() => onProjectClick(row)}
				sx={{
					flex: 1,
					minWidth: 0,
					cursor: 'pointer',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap'
				}}
			>
				{row.projectName}
			</RowTypography>
			<Box sx={{ ml: 1, flexShrink: 0 }}>
				{isNew(row?.updatedAt) && <SubscriptTag label="New" />}
			</Box>
		</Stack>
	);
};

const projectNameFormatter = (
	handleProjectClick: (row: any) => void
) => {
	return ({ row }: any) => (
		<ProjectCell
			row={row}
			onProjectClick={handleProjectClick}
		/>
	);
};

type ActionCellProps = {
	props: any;
	onAction: (type: string, action: string, props: any, event: any) => void;
};

export const ProjectActionCell = ({ props, onAction }: ActionCellProps) => {
	return (
		<Stack direction="row" alignItems="center" justifyContent="center" height="100%" width="100%">
			<MoreOptionMenu
				keysWithBorder={['copyToProgram']}
				menuItems={[
					{
						key: 'edit',
						label: 'Edit',
						icon: <EditIconNew />,
						color: '#000000',
						onMenuClick: (e: any) => onAction('Project', 'edit', props, e)
					},
					{
						key: 'duplicate',
						label: 'Duplicate',
						icon: <DuplicateIcon />,
						color: '#000000',
						onMenuClick: (e: any) => onAction('Project', 'duplicate', props, e)
					},
					{
						key: 'copyToProgram',
						label: 'Copy & Move Project to Program',
						icon: <MoveLeftIcon />,
						color: '#000000',
						onMenuClick: (e: any) => onAction('Project', 'copyToProgram', props, e)
					},
					{
						key: 'delete',
						label: 'Delete',
						icon: <DeleteIconNew />,
						color: '#FE2626',
						onMenuClick: (e: any) => onAction('Project', 'delete', props, e)
					}
				]}
				iconColor="#009BD8 !important"
				sx={{ width: '30px', height: '30px' }}
			>
			</MoreOptionMenu>
		</Stack>
	);
};

const projectActionFormatter = (
	handleAction: (type: string, action: string, props: any, event: any) => void
) => {
	return (props: any) => (
		<ProjectActionCell
			props={props}
			onAction={handleAction}
		/>
	);
};

const ProgramDetails = () => {
	const [, setSelectedRows] = useState<any>([]);
	const [, setAnchorElDetails] = React.useState<null | HTMLElement>(null);
	const [projectList, setProjectList] = useState<any>([]);
	const [openModal, setOpenModal] = useState<any>({ isOpen: false, message: '' });
	const [programDetail, setProgramDetail] = useState<any>({});
	const [loading, setLoading] = useState(false);
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const navigate = useNavigate();
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [errorMessage, setErrorMessage] = useState('');
	const [searchText, setSearchText] = useState('');
	const { id } = useParams();
	const [openConfirmationDialog, setOpenConfirmationDialog] = useState<any>({ isOpen: false, message: '', isUnlink: false, isQuery: false })
	const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
	const [copyModalTitle, setCopyModalTitle] = useState('Create Copy of Project To Program');
	const [copyModalWidth, setCopyModalWidth] = useState<'sm' | 'md' | 'lg' | 'xl'>('md');
	const [copySuccessInfo, setCopySuccessInfo] = useState<{ projectName: string; programName: string } | null>(null);

	const [selectedProjectRow, setSelectedProjectRow] = useState<any>(null);

	const defaultColumnNames = ['Project', 'Committed', 'Project Owner', 'Description',
		'Created Date', 'Updated By', 'Updated Date', 'Actions'];

	interface Row {
		projectId: string;
		projectName: string;
		projectOwner: string;
		projectDescription: string;
		committed: boolean;
		createdAt: string;
		updatedAt: string;
		updatedBy: string;
	}

	const handleDetailsThreeDotsClick = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setAnchorElDetails(event.currentTarget);
	};
	const handleDetailsThreeDotsClose = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		setAnchorElDetails(null);
	};

	const handleProjectClick = (row: any) => {
		navigate(
			`/finops/resourcemapping/projects/
				${id}/${row.projectId}/${encodeURIComponent(programDetail.programName)}/
				${encodeURIComponent(row.projectName)}`,
			{ state: { ...row, autoLoadOnMount: false } }
		);
	};

	function getColumns(): Array<Column<Row>> {
		const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return [
			{
				key: 'projectName',
				name: 'Project',
				minWidth: 200,
				width: 370,
				formatter: projectNameFormatter(
					handleProjectClick
				),
			},
			{
				key: 'projectOwner',
				name: 'Project Owner',
				minWidth: 200,
			},
			{
				key: 'projectDescription',
				name: 'Description',
				minWidth: 200,
			},
			{
				key: 'createdAt',
				name: 'Created Date',
				minWidth: 150,
				formatter({ row }) {
					return row.createdAt ? moment.utc(row.createdAt).tz(userTimezone).format('YYYY-MM-DD HH:mm') : '';
				}
			},
			{
				key: 'updatedBy',
				name: 'Updated By',
				minWidth: 200,
			},
			{
				key: 'updatedAt',
				name: 'Updated Date',
				minWidth: 150,
				formatter({ row }) {
					return row.updatedAt ? moment.utc(row.updatedAt).tz(userTimezone).format('YYYY-MM-DD HH:mm') : '';
				}
			},
			{
				key: 'action',
				name: 'Actions',
				width: 100,
				resizable: false,
				formatter: projectActionFormatter(handleAction)
			},
		];
	}

	const handleSorting = (e: any) => {
		getProjectsByProgram(page, pageSize, e, searchText);
	};

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		getProjectsByProgram(value, pageSize, sortingInfo, searchText);
	};

	const handlepageSizeChange = (event: any) => {
		getProjectsByProgram(page, event.target.value, sortingInfo, searchText);
	};

	const getProgramDetails = async () => {
		setLoading(true);
		let result = await getProgramDetailsById(id);
		setLoading(false);
		setProgramDetail(result.data ? result.data : '');
		navigate(`/finops/resourcemapping/programs/${id}/${encodeURIComponent(result.data.programName)}`);
	};

	const getProjectsByProgram = async (pageNumber: any, size: any, sortingInfo: any, searchText?: any) => {
		try {
			setLoading(true);
			let res = await getProjectListByProgramId(id, pageNumber, size, sortingInfo, searchText);
			if (res.success) {
				setLoading(false);
				setPaginationData(res.data.page);
				setPage(pageNumber);
				setPageSize(size);
				setSortingInfo(sortingInfo);
				const projData = res.data.projects.map((list: any) => {
					list['activeRow'] = 0;
					return list;
				});
				setProjectList(projData);
			}
		} catch (error) {
			console.error(error);
			if (typeof error === 'object' && error !== null && 'response' in error) {
				const err = error as { response: { status: number } };
				if (err.response.status === 503)
					eventEmitter.emit('showSnackbar', 'Service temporarily unavailable. Please try again later.', 'info');
				else if (err.response.status === 504) eventEmitter.emit('showSnackbar', 'Gateway Timeout', 'info');
			}
		}
	};

	const columnMap: { [key: string]: string } = {
		"Project": "Project",
		"Project Owner": "Project Owner",
		"Description": "Description",
	};

	async function exportTableData(sortingInfo: any, prefColumns: any, searchText?: any) {
		let formatType = 'EXCEL';
		let tableName = 'Finops_ProgramByProjectList';
		const exportColumns = prefColumns.map((prefCol: string) => columnMap[prefCol])
			.filter((col: string) => col !== null && col !== undefined);
		await exportProjectListByProgramId(id, exportColumns, formatType, tableName, sortingInfo, searchText);
	}

	const handleEditClose = (data: any) => {
		setOpenModal({
			...openModal,
			isOpen: false
		});
		setSelectedRows([]);
	};

	const onAddProjectClick = (event: any) => {
		setOpenModal({
			...openModal,
			isOpen: true,
			type: 'Project',
			action: 'ADD'
		});
	};

	const handleConfirmationDialogClose = () => {
		setOpenConfirmationDialog({
			...openConfirmationDialog,
			isOpen: false,
		});
	};

	const handleDuplicateUpdate = async (projectData: any) => {
		const formPayload = {
			projectId: projectData.data.projectId,
			projectName: projectData.data.projectName
		};
		const result = await fetchCopyProject(formPayload);
		if (result.success) {
			handleConfirmationDialogClose();
		}
	};

	const handleAction = (module: string, type: string, data: any, e: any) => {
		// debugger
		e.preventDefault();
		e.stopPropagation();
		if (data.row === undefined) {
			data = {
				...data,
				programName: programDetail.programName,
				programId: programDetail.programId
			};
		} else {
			data = {
				...data,
				programName: programDetail.programName,
				programId: programDetail.programId,
				projectId: data.row.projectId,
				projectName: data.row.projectName,
				projectOwner: data.row.projectOwner,
				projectDescription: data.row.projectDescription
			};
		}
		switch (type) {
			case 'edit':
				setOpenModal({
					...openModal,
					isOpen: true,
					type: module,
					action: 'EDIT',
					data: data
				});
				break;
			case 'duplicate':
				setOpenConfirmationDialog({
					...openConfirmationDialog,
					isOpen: true,
					data: data.row || data
				});
				break;
			case 'delete':
				setOpenModal({
					...openModal,
					isOpen: true,
					type: module,
					action: 'DELETE',
					from: 'view',
					data: data
				});
				break;
			case 'copyToProgram':
				setSelectedProjectRow({
					...data,
					projectId: data.row.projectId,
					projectName: data.row.projectName,
					projectOwner: data.row.projectOwner,
					projectDescription: data.row.projectDescription,
					programId: programDetail.programId,
					programName: programDetail.programName
				});

				setCopyModalTitle('Create Copy of Project To Program');
				setCopyModalWidth('md');

				setIsCopyModalOpen(true);
				break;
			case 'view':
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		const handleProgramDetailsSearch = (event: any) => {
			const text = event.detail?.searchText || '';
			setSearchText(text);
			setPage(1);
			getProjectsByProgram(1, pageSize, sortingInfo, text);
		};

		globalThis.addEventListener('programDetailsSearch', handleProgramDetailsSearch);
		return () => {
			globalThis.removeEventListener('programDetailsSearch', handleProgramDetailsSearch);
		};
	}, [pageSize, sortingInfo]);

	useEffect(() => {
		const activeId = document.getElementById('root');
		if (window.location.pathname.includes('/finops/resourcemapping/programs')) {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
			}
		}
		if (!openModal.isOpen && !openConfirmationDialog.isOpen) {
			getProgramDetails();
			setSortingInfo({ sortBy: '', sortDir: '' });
			sortingInfo.sortBy = sortingInfo.sortDir = '';
			getProjectsByProgram(page, pageSize, sortingInfo, searchText);
		}
	}, [openModal, openConfirmationDialog]);

	const getTruncatedValue = (value?: string, maxLength = 50): string => {
		if (!value) return '-';
		return value.length > maxLength
			? `${value.substring(0, maxLength)}...`
			: value;
	};

	return (
		<PageWrapper>
			{loading && <Loader />}
			<PageHeader
				headerSx={{ top: '86px !important' }}
				icon={DashboardIcon}
				title={[
					{
						text: 'Programs',
						link: '/finops/resourcemapping/programs'
					},
					{
						text: decodeURIComponent(window.location.pathname.split('/')[5].replace(/%20/g, ' '))
					}
				]}
			>
				<Stack direction="row" gap={1} alignItems="center">
					<Button variant="pepwiseSecondary" onClick={onAddProjectClick} startIcon={<AddIcon />}>
						ADD PROJECT
					</Button>
				</Stack>
			</PageHeader>

			<Dialog open={openModal.isOpen} onClose={handleEditClose} fullWidth={true} maxWidth="md">
				<ResourceMappingModal
					handleEditClose={handleEditClose}
					programData={openModal}
					errorMessage={errorMessage}
					setErrorMessage={setErrorMessage}
				/>
			</Dialog>
			<Dialog open={!!errorMessage} maxWidth="sm">
				<DialogContent
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px'
					}}
				>
					<ErrorOutlineIcon sx={{ color: 'red', fontSize: '22px' }} />
					<Typography>{errorMessage}</Typography>
				</DialogContent>
				<DialogActions
					sx={{
						pr: '1rem',
						pb: '1rem'
					}}
				>
					<Button onClick={() => setErrorMessage('')} variant="pepwiseSecondary">
						OK
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={openConfirmationDialog.isOpen} onClose={handleConfirmationDialogClose} fullWidth={true} maxWidth="md">
				<ProjectConfirmationDialog
					handleDialogClose={handleConfirmationDialogClose}
					projectData={openConfirmationDialog}
					handleSave={handleDuplicateUpdate}
				/>
			</Dialog>
			<Stack spacing={2} mt={4}>
				<Grid container spacing={1}>
					<Grid item xs={12} md={12}>
						<DataInfoSecondary
							infoCards={[
								{
									label: 'Program Name',
									value: getTruncatedValue(programDetail?.programName),
									isLoading: !programDetail?.programName,
									valueProps: {
										fontSize: '16px',
										fontWeight: 400,
										lineHeight: '26px',
										sx: {
											overflow: 'hidden',
											textOverflow: 'ellipsis'
										},
										title: programDetail?.programName
									},
									maxWidth: '24rem',
								},
								{
									label: 'Program Owner',
									value: getTruncatedValue(programDetail?.programOwner, 35),
									isLoading: !programDetail?.programOwner,
									valueProps: {
										fontSize: '16px',
										fontWeight: 400,
										lineHeight: '26px',
										sx: {
											overflow: 'hidden',
											textOverflow: 'ellipsis'
										},
										title: programDetail?.programOwner
									},
									maxWidth: '24rem',
								},
								{
									label: 'Program Description',
									value: getTruncatedValue(programDetail?.programDescription),
									isLoading: !programDetail,
									valueProps: {
										fontSize: '16px',
										fontWeight: 400,
										lineHeight: '26px',
										sx: {
											overflow: 'hidden',
											textOverflow: 'ellipsis'
										},
										title: programDetail?.programDescription
									},
									maxWidth: '24rem',
								},
								{
									label: 'Total Cost (YTD)',
									value: programDetail.finalCost && programDetail.finalCost !== 'null' ?
										`$${formatNumberWithCommas(programDetail.finalCost)}` : '-',
									isLoading: loading,
									valueProps: {
										fontSize: '16px',
										fontWeight: 400,
										lineHeight: '26px'
									},
									maxWidth: '24rem',
									hasTooltip: true
								},
							]}
							infoTooltip={{
								dateValues: [
									{ label: 'Date Created', value: programDetail?.createdAt ?? 'NA' },
									{ label: 'Last Updated', value: programDetail?.updatedAt ?? 'NA' }
								]
							}}
							infoOptionMenu={{
								onClick: handleDetailsThreeDotsClick,
								onClose: handleDetailsThreeDotsClose,
								menuItems: [
									{
										key: 'edit',
										label: 'Edit',
										icon: <EditIcon />,
										color: '#000000',
										onMenuClick: (e) => handleAction('Program', 'edit', {}, e)
									},
									{
										key: 'delete',
										label: 'Delete',
										icon: <DeleteIcon />,
										color: '#000000',
										onMenuClick: (e) => handleAction('Program', 'delete', {}, e)
									}
								]
							}}
							bgColor="#FBFDFF"
							isAdmin={true}
							sx={{ boxShadow: '4px 8px 54px 0px #00000014', color: '#000000' }}
						/>
					</Grid>
				</Grid>
				<Grid item xs={12} p={1}>
					<CustomizedDataGrid
						tableColumns={getColumns()}
						tableData={projectList}
						tableType="project-list"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						page={page}
						pageSize={pageSize}
						paginationData={paginationData}
						listLength={projectList.length}
						showExport={true}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isDateRangeFilter={false}
						isDisabled={false}
						isShowMoreButton={true}
						exportTableData={(prefColumns: any) => exportTableData(sortingInfo, prefColumns, searchText)}
						title="Projects"
						isSortIcon={true}
					/>
				</Grid>
			</Stack>
			{/* Copy Project To Program modal */}
			<DialogueModal
				isOpen={isCopyModalOpen}
				handleClose={() => setIsCopyModalOpen(false)}
				title={copyModalTitle}
				width={copyModalWidth}
				titleSx={{ px: 3, py: 2 }}
			>
				<CopyToProgramModal
					projectData={selectedProjectRow}
					onCancel={() => {
						setIsCopyModalOpen(false);
					}}
					onConfirm={(data) => {
						setIsCopyModalOpen(false);
						setCopySuccessInfo(data);
						getProjectsByProgram(
							page,
							pageSize,
							sortingInfo
						);
					}}
					onTitleChange={(title: string) => {
						setCopyModalTitle(title);
					}}
					onWidthChange={(width: 'sm' | 'md' | 'lg' | 'xl') => {
						setCopyModalWidth(width);
					}}
				/>
			</DialogueModal>

			{/* Copy to Program success toast */}
			<Snackbar
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={!!copySuccessInfo}
				autoHideDuration={6000}
				onClose={() => setCopySuccessInfo(null)}
			>
				<Alert
					onClose={() => setCopySuccessInfo(null)}
					severity="success"
					sx={{
						backgroundColor: '#ffffff !important',
						color: '#000000 !important',
						border: '1px solid #E4EDFF',
						boxShadow: '0px 4px 16px rgba(0,0,0,0.12)',
						'& .MuiAlert-icon': { color: '#01C008 !important', alignItems: 'center', fontSize: '22px' },
						'& .MuiAlert-action button': { color: '#000000 !important' },
						'&.MuiPaper-root': { padding: '8px 16px !important' },
						minWidth: '320px',
					}}
				>
					<Typography style={{ fontSize: '16px', fontWeight: '700', color: '#01C008', marginBottom: '4px' }}>
						Project Successfully Copied {'&'} Moved
					</Typography>
					<Typography style={{ fontSize: '14px', fontWeight: '400', color: '#000000' }}>
						Project{' '}
						<span style={{ color: '#009BD8', textDecoration: 'underline', cursor: 'pointer' }}>
							{copySuccessInfo?.projectName}
						</span>{' '}
						copied and moved in{' '}
						<span style={{ color: '#009BD8', textDecoration: 'underline', cursor: 'pointer' }}>
							{copySuccessInfo?.programName}
						</span>.
					</Typography>
				</Alert>
			</Snackbar>
		</PageWrapper>
	);
};

export default ProgramDetails;

